import Player from "@vimeo/player";

export function renderTemplate(template, obj) {
  let rectangle_bg = "";
  let square_bg = "";

  if (obj.rect_img) {
    rectangle_bg = `${obj.rect_img.sizes.medium} 320w, ${obj.rect_img.sizes.large} 640w, ${obj.rect_img.sizes.large} 640w, ${obj.rect_img.sizes["1536x1536"]} 1024w`;
  }
  if (obj.square_img) {
    square_bg = `${obj.square_img.sizes.medium} 320w, ${obj.square_img.sizes.large} 640w`;
  }

  let tpl = template
    .replace(/{{title}}/gi, obj.title)
    .replace(/{{link}}/gi, obj.link)
    .replace(/{{image}}/gi, obj.img)
    .replace(/{{classes}}/gi, obj.classes)
    .replace(/{{rectangle}}/gi, rectangle_bg)
    .replace(/{{square}}/gi, square_bg)
    .replace(/{{video}}/gi, obj.video || "")
    .replace(/{{text_color}}/gi, obj.text_color)
    .replace(/{{bg_color}}/gi, obj.bg_color)
    .replace(/{{text_align}}/gi, obj.text_align)
    .replace(/{{shadow_size}}/gi, obj.shadow)
    .replace();

  return tpl;
}

// Adds Pagination to content-grid categories
function addPagination(e) {
  $ = jQuery;

  let loadMore = $.trim($("#load-more-tpl").html());
  let article_limit = 99; // parseInt($(this).attr("data-articles-per-page")) || 15;
  let total_articles = $(this).children(".flow-block").length;

  if (total_articles > article_limit) {
    let first_page = true;
    $(this).removeClass("flow-container");

    // While category have article children, move them to a new page
    while ($(this).children(".flow-block").length) {
      let page_class = "flow-container flow-block-category__page";

      // Add active-class to the first page
      if (first_page) {
        page_class += " active";
        first_page = false;
      }

      $(this).append(`<div class="${page_class}" />`);
      $(".flow-block-category__page:last-child", this).append(
        $(this)
          .children(".flow-block")
          .slice(0, article_limit)
      );
    }

    $(this).append(loadMore);
    console.log("hello");
  } else {
    // Create one page and populate it
    let page_class = "flow-container flow-block-category__page active";

    $(this).append(`<div class="${page_class}" />`);
    $(".flow-block-category__page:last-child", this).append(
      $(this).children(".flow-block")
    );
  }
}

// Event to show more articles
function showNextGridPage(e) {
  var cat = $(this).parents(".flow-block-category");
  // $(this).parents('.flow-block-category').children('.flow-block-category__page:not')
  // Add class to parent

  var next_page = $(".flow-block-category__page:not(.active):first", cat);
  $(".flow-block-category__page:not(.active):first", cat).addClass("active");

  // Check if we need to hide the loadMore button
  if ($(".flow-block-category__page:not(.active)", cat).length <= 0) {
    $(this)
      .parent()
      .addClass("hidden");
  }
}

export function initContentGrid($) {
  // Filter content-grid
  // Do stuff
  var filterFlow = function(section) {
    if (section != "everything") {
      // $(".flow-block-category").fadeOut(0, function () {
      $(".flow-block-category").removeClass("active");

      // $(".flow-block-category--" + section).fadeIn(300, function () {
      //   articleGrid.scrollIntoView({
      //     behavior: "smooth",
      //   });

      $(".flow-block-category--" + section).addClass("active");
      // });
      // });

      $(".filter-menu-item").removeClass("active");

      $(".filter-menu-" + section).addClass("active");
    } else {
      $(".flow-block-category").removeClass("active");
      $(".filter-menu-item").removeClass("active");
      $(".filter-menu-everything").addClass("active");
      // $(".flow-block-category--everything").fadeIn(300, function () {
      //   articleGrid.scrollIntoView({
      //     behavior: "smooth",
      //   });
      $(".flow-block-category--everything").addClass("active");
      // });
    }
  };

  $(".grid-filter__select").on("change", function() {
    filterFlow(this.options[this.selectedIndex].value);
  });

  // Check if Articles Object exist
  if (typeof articles_by_cat !== "undefined") {
    // Content Grid Template
    var template = $.trim($("#flow-block-tpl").html());
    var templateNoLink = $.trim($("#flow-block-no-link-tpl").html());

    // Method for fetching correct template
    function getTemplate(obj) {
      return obj.use_link ? template : templateNoLink;
    }

    // Single category?
    if ($(".content-grid").data("grid-categories") == "single") {
      // Loop through main category
      $(".content-grid").append(
        `<div class="flow-container flow-block-category flow-block-category--${main_category} active col-size-${grid_section_config[main_category].col_size}" data-col-size="${grid_section_config[main_category].col_size}"  data-articles-per-page="${grid_section_config[main_category].articles_per_page}"></div>`
      );
      var cat_container = $(
        `.content-grid .flow-block-category--${main_category}`
      );

      // Check for priority
      if (main_category == "everything") {
        // Loop through all priority stuff
        $.each(grid_section_config.everything.priority_articles, function(
          index,
          obj
        ) {
          // Add Classes, then render template
          obj.classes = "flow-block--priority flow-block--1-3 active";
          let x = renderTemplate(getTemplate(obj), obj);

          cat_container.append(x);
        });
      } else {
        $.each(grid_section_config[main_category].priority_articles, function(
          index,
          obj
        ) {
          // Add Classes, then render template
          obj.classes = "flow-block--priority flow-block--1-3 active";
          let x = renderTemplate(getTemplate(obj), obj);

          cat_container.append(x);
        });
      }

      $.each(articles_by_cat[main_category], function(index, obj) {
        // Add Classes, then render template
        obj.classes = "flow-block--1-3 active";
        let x = renderTemplate(getTemplate(obj), obj);

        cat_container.append(x);
      });
    } else {
      // Loop through categories
      for (var cat in articles_by_cat) {
        $(".content-grid").append(
          `<div class="flow-container flow-block-category flow-block-category--${cat} col-size-${grid_section_config[cat].col_size}" data-col-size="${grid_section_config[cat].col_size}" data-articles-per-page="${grid_section_config[cat].articles_per_page}"></div>`
        );
        var cat_container = $(`.content-grid .flow-block-category--${cat}`);
        if (main_category == cat) {
          cat_container.addClass("active");
        }

        // Check for priority
        // Loop through all priority stuff
        $.each(grid_section_config[cat].priority_articles, function(
          index,
          obj
        ) {
          // Add Classes, then render template
          obj.classes = "flow-block--priority flow-block--1-3 active";
          var x = renderTemplate(getTemplate(obj), obj);

          // Add to both all container and category container
          cat_container.append(x);
        });

        $.each(articles_by_cat[cat], function(index, obj) {
          // Add Classes, then render template
          obj.classes = "flow-block--1-3 active";
          var x = renderTemplate(getTemplate(obj), obj);

          // Add to both all container and category container
          cat_container.append(x);
        });
      }
    }

    $(".flow-block[data-video!=''][data-video!='null'][data-video]").each(
      function(index) {
        let video_id = $(this).data("video");
        const video_autoplay = true;
        const video_loop = true;
        const video_muted = true;
        const video_controls = false;
        const video_background = true;

        if (isNaN(video_id)) {
          video_id = Number(video_id.replace(/\D/g, ""));
        }

        const options = {
          id: video_id,
          width: 1900,
          autoplay: video_autoplay,
          loop: video_loop,
          muted: video_muted,
          controls: video_controls,
          background: video_background,
          responsive: true
        };

        // Add video container
        $(this).append('<div class="flow-block__video-container"></div>');

        const player = new Player(
          $(".flow-block__video-container", this)[0],
          options
        );
      }
    );

    // Shuffle all flow-blocks
    $(".flow-block-category").each(function() {
      if ($(this).children().length > 1) {
        $(this).shuffle();
      }
    });

    // Move prioritized to top
    $(".flow-block--priority").each(function() {
      $(this).prependTo($(this).parent());
    });

    // Articles now in place in correct order
    // Create pagination for sections that need it
    $(".flow-block-category").each(addPagination);

    $(document).on(
      "click",
      ".content-grid .load-more-button",
      showNextGridPage
    );
  }

  // Add grid-filter handlers
  $(".filter-menu-item[data-grid-filter]").on("click", function() {
    filterFlow($(this).data("grid-filter"));

    // If window top is more than 300px below from wrapper-grid-filter, animate up
    if ($(window).scrollTop() > $(".content-grid").offset().top + 300) {
      $("html, body").animate(
        {
          scrollTop: $(".content-grid").offset().top
        },
        250
      );
    }

    // Assign mobile select
    $(".grid-filter__select").val($(this).data("grid-filter"));

    if ($(".main-menu__container.show-grid-container").length) {
      // If window top is more than 300px below from wrapper-grid-filter, animate up
      $(".main-menu__container, .menu-burger").toggleClass("active");
      $(".wrapper").toggleClass("blur");
      $(".main-logo").toggleClass("on-menu");
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/content-grid.js